import client from '../../lib/service/geolocation.service';

type Params = Partial<{
  latitude: number;
  longitude: number;
  address: string;
}>;

const GEOCODE_API = '/api/geocode';

export const findGeocode = async (params: Params) => {
  const response = await client.get(GEOCODE_API, { params });
  return response.data;
};
